<template>
  <div class="training-wrapper">
    <!-- <button class="button secondary" @click.prevent="addReg">Create New Registration</button> -->
    <div class="table-wrapper">
      <table>
        <thead>
          <tr class="tbl-hdr-bg">
            <th>Unit</th>
            <th>Training</th>
            <th>Participant</th>
            <th>Billing Info</th>
            <th>Has guide?</th>
            <th>Date Submitted</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="registration in registrations" :key="registration.index">
            <td class="vert-middle">{{ registration.unit }}</td>
            <td class="left">{{ registration.title }}<br />Date(s): {{ registration.sessionOne }}<span v-if="registration.sessionTwo !== 'N/A'">, {{ registration.sessionTwo }}</span><br />Time: {{ registration.time }}</td>
            <td class="left">{{ registration.participantFirstName }} {{ registration.participantLastName }}<br /> <a :href="'mailto:${registration.participantEmail}'" target="_blank">{{ registration.participantEmail }}</a></td>
            <td class="left"><b>{{ registration.district }}</b><br />{{ registration.billingAddress }}<br />{{ registration.billingCity }}, {{ registration.billingState }} {{ registration.billingZip }}</td>
            <td class="vert-middle">{{ registration.hasGuide }}</td>
            <td class="vert-middle">{{ registration.formattedDateSubmitted }}</td>
            <td class="vert-middle"><a class="button small" @click.prevent="viewDetails(registration.registrationId)">Details</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
import moment from 'moment'
export default {
  data() {
    return {
      registrations: []
    }
  },
  methods: {
    fetchRegistrations() {
      fb.trainingRegistrationsCollection.where('sortDate', '>', '2026-06-01').orderBy('sortDate', 'asc').orderBy('unit', 'asc').get().then((snap) => {
        snap.forEach((doc) => {
          if (doc.data().active !== false) {
            this.registrations.push({
            registrationId: doc.id,
            unit: doc.data().unit,
            trainingId: doc.data().trainingId,
            title: doc.data().title,
            time: doc.data().time,
            sessionOne: doc.data().sessionOne,
            sessionTwo: doc.data().sessionTwo,
            sessionThree: doc.data().sessionThree,
            sortDate: doc.data().sortDate,
            district: doc.data().district,
            building: doc.data().building,
            purchaseOrder: doc.data().purchaseOrder,
            participantFirstName: doc.data().participantFirstName,
            participantLastName: doc.data().participantLastName,
            participantEmail: doc.data().participantEmail,
            hasGuide: doc.data().hasGuide,
            billingAddress: doc.data().billingAddress,
            billingCity: doc.data().billingCity,
            billingState: doc.data().billingState,
            billingZip: doc.data().billingZip,
            dateSubmitted: doc.data().dateSubmitted,
            formattedDateSubmitted: moment(doc.data().dateSubmitted.toDate()).format('LL'),
            active: doc.data().active
          })
          }
        })
      }).then(() => {
        // console.log(this.registrations)
      })
    },
    viewDetails(id) {
      this.$store.commit('SET_REGISTRATION_TO_EDIT', id)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'trainingRegDetails')
    },
    addReg() {
      this.$store.commit('SET_DISTRICT_ID', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
      this.$router.push('/training')
    }
  },
  mounted() {
    this.fetchRegistrations()
  }
}
</script>

<style lang="css" scoped>
.table-wrapper {
  margin: auto;
  margin-bottom: 20px;
  border: 2px solid #cecece;
  border-radius: 5px;
  overflow: hidden;
  max-width: fit-content;
}
table {
  border-collapse: collapse;
  background-color: white;
  font-size: .95em;
}
th,td {
  border: 1px solid #cecece;
  padding: 5px 15px;
}
th {
  border-top: 0;
}
th:first-child {
  border-radius: 3px 0 0 0;
  border-left: 0;
}
th:last-child {
  border-right: 0;
  border-radius: 0 3px 0 0;
}
tbody>tr>:last-child {
  border-right: 0;
}
tbody>tr>:first-child {
  border-left: 0;
}
tbody>:last-child {
  /* background: pink;
  border-bottom: 0; */
}
.table-body>tr:last-child {
  /* background: green; */
  border-bottom: 0;
}

/* tr:last-child td:first-child {
   border-radius: 0 0 25px 0;
}
tr:last-child td:last-child {
   border-radius: 0 0 0 25px;
} */
.row-bg {
  background-color: lightgrey;
}
.tbl-hdr-bg {
  font-size: 1.2em;
  background-color: #f47e20;
  color: white;
}
tr:nth-child(even){
  background-color: #e6e6e6;
}
.unitColumn {
  text-align: left;
}
td {
  vertical-align: top;
}
.left {
  text-align: left;
}
.vert-middle {
  vertical-align: middle;
}

</style>
